import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import RequestPromoteFlowStep from './RequestPromoteFlowStep'

class RoleLevelSalaryStep extends RequestPromoteFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.request_promote.steps.role_level_salary.title'),
      component,
      i18n.t('contract_versions.flows.request_promote.steps.role_level_salary.description')
    )
  }
}

export default RoleLevelSalaryStep
